import React, { useState } from "react";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const TopDiagnosis = ({ diagnosisData }) => {
    const [selectedDiagnosis, setSelectedDiagnosis] = useState(diagnosisData[0]?.diagnosis);

    return (
        <div className="bg-white rounded-xl shadow p-6 flex gap-6">
            {/* Left Summary Section */}
            <div className="w-[30%] space-y-4">
                <h3 className="text-md font-semibold text-[#003A71]">Summary</h3>

                {diagnosisData.map((item) => (
                    <div
                        key={item.diagnosis}
                        className={`p-3 rounded-lg border cursor-pointer ${selectedDiagnosis === item.diagnosis
                                ? "border-blue-400 bg-blue-50"
                                : "border-blue-100 bg-white hover:bg-blue-50"
                            }`}
                        onClick={() => setSelectedDiagnosis(item.diagnosis)}
                    >
                        <div className="text-sm text-gray-600">{item.diagnosis}</div>
                        <div className="text-xl font-bold text-[#00B5E2]">{item.count}</div>
                    </div>
                ))}
            </div>

            {/* Right Chart Section */}
            <div className="w-[70%]">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-md font-semibold text-[#003A71]">Top Diagnosis</h3>
                </div>

                <ResponsiveContainer width="100%" height={400}>
                    <AreaChart data={diagnosisData} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
                        <defs>
                            <linearGradient id="colorDiagnosis" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#00B5E2" stopOpacity={0.6} />
                                <stop offset="100%" stopColor="#00B5E2" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid vertical={false} stroke="#f0f0f0" />
                        <XAxis dataKey="diagnosis" axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#666" }} />
                        <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11, fill: "#666" }} />
                        <Tooltip contentStyle={{ borderRadius: 6, fontSize: 11, padding: 6 }} itemStyle={{ fontSize: 11 }} formatter={(val) => [val, "Patients"]} />
                        <Area
                            type="monotone"
                            dataKey="count"
                            stroke="#00B5E2"
                            fill="url(#colorDiagnosis)"
                            dot={(props) => {
                                const { cx, cy, payload } = props;
                                const isActive = payload.diagnosis === selectedDiagnosis;
                                return <circle cx={cx} cy={cy} r={isActive ? 6 : 3} fill={isActive ? "#003A71" : "#00B5E2"} stroke={isActive ? "#003A71" : "#00B5E2"} />;
                            }}
                            activeDot={{ r: 6, fill: "#003A71", stroke: "#003A71" }}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default TopDiagnosis;
